import { render } from "./TmDashboard.vue?vue&type=template&id=09edf972&scoped=true"
import script from "./TmDashboard.vue?vue&type=script&lang=js"
export * from "./TmDashboard.vue?vue&type=script&lang=js"

import "./TmDashboard.vue?vue&type=style&index=0&id=09edf972&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09edf972"]])

export default __exports__